import React, { useState } from "react";
import styles from "../styles/Thank-you.module.css";

interface FAQItemProps {
  question: string;
  answer: string;
}

const FAQItem: React.FC<FAQItemProps> = ({ question, answer }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleOpen = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className={`${styles.faqItem} ${isOpen ? styles.expanded : ""}`} onClick={toggleOpen}>
      <div className={styles.faqQuestion}>
        <span>{question}</span>
        <span className={styles.faqToggleIcon}>
          {isOpen ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className={styles.faqIcon}
            >
              <polyline points="18 15 12 9 6 15" /> {/* Arrow Up */}
            </svg>
          ) : (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className={styles.faqIcon}
            >
              <polyline points="6 9 12 15 18 9" /> {/* Arrow Down */}
            </svg>
          )}
        </span>
      </div>
      <div className={styles.faqAnswer}>
        {answer}
      </div>
    </div>
  );
};

export default FAQItem;
